import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import App from '@app';
import { Body, PageHeader, AddButton } from '@components';
import { useDispatch, useSelector } from 'react-redux';
import { getTemplateGrupo } from '@ducks/conectoresTemplatesGrupos';
import TableTemplates from './TableTemplates';

export default function Templates() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { idGrupo } = useParams();

  const templateGrupo = useSelector(({ conectoresTemplatesGrupos }) => conectoresTemplatesGrupos.get('templateGrupo'));

  useEffect(() => {
    dispatch(getTemplateGrupo(idGrupo));
  }, []);

  return (
    <App>
      <Body>
        <PageHeader
          title={`Templates${templateGrupo?.ds ? ` - ${templateGrupo.ds}` : ''}`}
          onBack={() => history.goBack()}
          extra={[
            <AddButton
              key='1'
              type='primary'
              tooltipTitle='Adicionar Template'
              style={{ marginBottom: 10 + 'px', borderRadius: 5 + 'px' }}
              onClick={() => history.push(`/conectores/templates/cadastro/${idGrupo}/-1`)}
            />,
          ]}
        >
          <TableTemplates />
        </PageHeader>
      </Body>
    </App>
  );
}
